import { Pipe, PipeTransform } from '@angular/core';

@Pipe({	name: 'escape' })

export class EscapePipe implements PipeTransform {

	transform(value: string): any {
		if (value == null) {
			return "";			
		} else {
			return new DOMParser().parseFromString(value, "text/html").documentElement.textContent;
		}
	}
}
